export default "__VITE_PUBLIC_ASSET__022164e4__"